export const scoreSummary = {
  score: 96.8,
  status: "Verified",
};

export const aiSummary = {
  lastUpdated: "Dec 22, 2025 09:23 UTC",
  executive:
    "Identity verification remains strong at 96.8%. However, 3.2% of sessions are failing due to expired device certificates in the SCADA zone. Recommend automated certificate renewal for 45 IoT sensors.",
  confidence: "91% (High)",
  methodology: "Behavioral analytics with continuous device posture checks.",
};

export const recommendedActions = [
  {
    priority: "Critical Priority",
    priorityTone: "priorityCritical",
    borderColor: "#dc2626",
    title: "Renew Expired Device Certificates",
    description:
      "45 certificates in Zone B are past their validity date, causing connection drops.",
    cve: "Certificate Expiry",
  },
  {
    priority: "High Priority",
    priorityTone: "priorityHigh",
    borderColor: "#f59e0b",
    title: "Enforce MFA for Contractor VPN",
    description:
      "12 external partners are accessing the Corporate Network without hardware-token verification.",
    cve: "MFA Gap",
  },
  {
    priority: "Medium Priority",
    priorityTone: "priorityMedium",
    borderColor: "#38bdf8",
    title: "Audit Over-privileged Service Accounts",
    description:
      "5 system accounts have not been rotated in 180 days.",
    cve: "Access Hygiene",
  },
];

export const riskTrend = [
  { month: "Jan", score: 96 },
  { month: "Feb", score: 93 },
  { month: "Mar", score: 88 },
  { month: "Apr", score: 84 },
  { month: "May", score: 78 },
  { month: "Jun", score: 74 },
  { month: "Jul", score: 70 },
  { month: "Aug", score: 66 },
  { month: "Sep", score: 62 },
  { month: "Oct", score: 52 },
  { month: "Nov", score: 48 },
  { month: "Dec", score: 40 },
];

export const riskFactors = [
  {
    id: "Admin_01",
    category: "User",
    verificationStatus: "Verified",
    postureCheck: "MFA Active",
    riskLevel: "Low",
  },
  {
    id: "IoT-247",
    category: "Sensor",
    verificationStatus: "Failed",
    postureCheck: "Expired Certificate",
    riskLevel: "High",
  },
  {
    id: "HMI-3",
    category: "Workstation",
    verificationStatus: "Verified",
    postureCheck: "Patch Level Current",
    riskLevel: "Low",
  },
  {
    id: "Contractor_Ext",
    category: "User",
    verificationStatus: "Pending",
    postureCheck: "No MFA Detected",
    riskLevel: "Medium",
  },
];
